var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconBathOrShower = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.184 4.623a.623.623 0 0 1 1.064-.44l.699.698a3.725 3.725 0 0 0 .638 3.806c-.25.432-.188.99.177 1.36.44.44 1.153.44 1.59 0l4.879-4.875a1.125 1.125 0 0 0-1.36-1.767 3.705 3.705 0 0 0-2.437-.905 3.78 3.78 0 0 0-1.369.258l-.698-.699a3.623 3.623 0 0 0-6.183 2.564V13c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h21c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-18V4.623zm-3 12.877v.75c0 1.331.581 2.531 1.5 3.356V23.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-.75h12v.75c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-1.894a4.496 4.496 0 0 0 1.5-3.356v-.75h-21z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBathOrShower, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-bath-or-shower.da2c2b27.svg";
export { ForwardRef as ReactComponent };